import { Box, Typography, Grid } from "@mui/material";
import { motion } from "framer-motion";
import TeamCard from "./TeamCard";

const teamMembers = [
  {
    name: "Manish Chaudhary",
    role: "Full Stack Developer",
    description: "Passionate about building scalable web applications with modern technologies.",
    image: "/ManishImg.jpg",
    socials: { github: "https://github.com/manish123297", instagram: "#", linkedin: "https://www.linkedin.com/in/manish-chaudhary-1b01221b2" },
  },
  {
    name: "Arun Goril",
    role: "Full Stack Developer",
    description: "Focused on creating intuitive user experiences with clean code.",
    image: "/ArunImg.jpg",
    socials: { github: "https://github.com/ArunGoril", instagram: "https://www.instagram.com/arun_goril/#", linkedin: "https://www.linkedin.com/in/arungoril" },
  },
];

const TeamGrid = () => (
  <Box id="team-section" sx={{ py: { xs: 4, md: 8 }, px: { xs: 2, sm: 4 }, backgroundColor: "#fff" }}>
    <Box sx={{ maxWidth: "1200px", mx: "auto", textAlign: "center", mb: 8 }}>
      <motion.div initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
        <Typography
          variant="h3"
          component="h2"
          sx={{
            fontWeight: 800,
            mb: 2,
            fontSize: { xs: "2rem", md: "3rem" },
            background: "linear-gradient(45deg, #001d3d 0%, #42a5f5 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Meet Our Team
        </Typography>
        <Typography variant="h6" component="p" sx={{ maxWidth: "700px", mx: "auto", color: "#616161", fontSize: { xs: "1rem", md: "1.25rem" } }}>
          The passionate individuals behind FindMyRoommates
        </Typography>
      </motion.div>
    </Box>
    <Grid container justifyContent="center" sx={{ maxWidth: "1200px", mx: "auto" }}>
      {teamMembers.map((member, index) => (
        <Grid item xs={12} sm={6} md={4} key={index} sx={{ px: { xs: 2, md: 3 }, mb: { xs: 4, md: 6 } }}>
          <TeamCard member={member} index={index} />
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default TeamGrid;